import(/* webpackMode: "eager" */ "/home/jr/FrontEnd/app/page.tsx");
